// Simple function that return: N/A when there is no value to show

const valueValidator = (input) => {
	if (input === '' || input === null || input === undefined) return 'N/A';
	return input;
};

export default valueValidator;
